import { s, Shape } from "@kosmod/pancake"

import { mini } from "./mini"
import { selection } from "./selection"
import { terrain } from "./terrain"
import { dev } from "./dev"
import { dice } from "./dice"
import { ToolID } from "./define"
import { ID } from "@kosmod/kit"

const toolDefList = [
  mini.place,
  mini.move,
  mini.delete,
  
  selection.deselect,
  selection.select,

  terrain.paint.brush,

  dev.vis,
  dice.cleanup,
  dice.roll,
]
export type Tool = (typeof toolDefList)[number];
export type ToolKey = Tool["key"];

export type ToolByKey = {
  [Key in ToolKey]: Extract<Tool, { key: Key }>
}


export const tools = {
  terrain,
  dice,
  mini,
  selection,
  dev,

  create<T extends ToolKey>(type: T, state: Shape.Type.Of<ToolByKey[T]["state"]>): ToolState  {
    return { ...(state as ToolStateRaw), type: type as ToolState["type"], id: ID('theatre:tool') } as ToolState
  }
}

export const ToolStateRaw = s.du(
  'type',
  Object.fromEntries(toolDefList.map(tool =>
    [tool.key, tool.state.properties])) as {
      [Key in ToolKey]: Extract<Tool, { key: Key }>['state']['properties']
    }
);

/**
 * Without ID - just the raw state of a tool + the tool type.
 * Used for passing over the network.
 */
export type ToolStateRaw = Shape.Type.Of<typeof ToolStateRaw>;

export type ToolState = { id: ToolID } & ToolStateRaw;
